import styled from "styled-components";
import imagen from "../assets/AEREA.jpg" 

export const Contenedorimagen=styled.div`
    background-size: cover; 
    background-image: url(${imagen});
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-position: center center;
    background-color: rgba(10, 19, 38, 0.45);
    background-blend-mode: soft-light;
    height: 100%;
    width: 100%;
`